import React from 'react';
import { AccordionProvider } from './context';

const AccordionManager = ({ children, ...rest }) => <AccordionProvider {...rest}>{children}</AccordionProvider>

export default AccordionManager;
